module.exports = __webpack_public_path__ + "static/media/ic-qr-fab.ed1b10bf.svg";